var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243:13499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7626 5.27727C21.1908 8.70544 21.1908 14.265 17.7626 17.6932C16.5486 18.9072 15.0656 19.6866 13.5067 20.0453L13.5067 18.0312C14.5552 17.7139 15.5554 17.1414 16.3831 16.3136C19.0456 13.6511 19.0456 9.31934 16.3831 6.65682C13.7206 3.9943 9.38878 3.9943 6.72626 6.65682L6.609 6.77408L8.79558 6.78098L8.79558 8.72614L3.2774 8.72614L3.2774 3.20796L5.22945 3.20106L5.22945 5.39454L5.34672 5.27727C8.77489 1.8491 14.3345 1.8491 17.7626 5.27727ZM11.5547 11.4852L11.5547 19.7625L3.2774 19.7625L3.2774 11.4852L11.5547 11.4852ZM9.60261 17.8104L9.60261 13.4373L5.22945 13.4373L5.22945 17.8104L9.60261 17.8104Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243:13499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate_left.84b88e4f2bbc0094d7ad2cc77fd0cd27.svg";
export { ForwardRef as ReactComponent };